import {pick} from 'lodash';
import FormModel from '@baidu/ve-ria/views/FormModel';

export default class MaterialPreviewFormModel extends FormModel {

    title = '预览物料';

    /**
     * @override
     */
    init() {
        super.init();

        this.id = this.getRouteParams().id;
        this.detailRequester = this.api.landingCustomMaterialDetail;
    }

    /**
     * @override
     */
    formData = {
        name: '',
        landingName: '',
        previewUrl: '',
        phoneType: '',
        qrCodeUrl: ''
    };

    /**
     * @override
     */
    adaptData(data) {
        return pick(data, ['name', 'landingName', 'previewUrl', 'phoneType', 'qrCodeUrl']);
    }
}
